import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "../../../utils/withRouter";
import {
  timeslot_add_action,
  timeslot_detail_action,
} from "../../../actions/master_actions/timeSlot_action";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Loader from "../../../utils/Loader";
import Header from "../../../common_components/Header";
import { TimePicker } from "@hilla/react-components/TimePicker.js";
import {
  sessionExpireMessage,
  tokenInavlidMessage,
} from "../../../utils/constants";

class seatingTypeAU extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      isOpen: false,
      userId: "",
      TimeSlotID: "",
      StatusID: "",
      TimeSlotName: "",
      FromTime: "",
      ToTime: "",
      SelectedHrs: "",
      Description: "",
      timeslotData: [],
      //input validate
      TimeSlotNameErr: "",
      FromTimeErr: "",
      ToTimeErr: "", DurationErr: "",
      slotType: false,
    };
    this.navigateBackList = this.navigateBackList.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.timeSlotDetails = this.timeSlotDetails.bind(this);
    this.clearFields = this.clearFields.bind(this);
  }
  componentDidMount() {
    console.log(this.props.location);
    if (JSON.parse(sessionStorage.getItem("UserLoginData")) == null) {
      console.log("log");
      setTimeout(() => {
        this.props.navigate("/login");
      }, 500);
    }
    setTimeout(() => {
      {
        sessionStorage.getItem("roleId") == 4 ? (
          this.props.navigate("/checkList")
        ) : (
          <></>
        );
      }
    }, 10);
    const { userId, Status } = this.state;
    this.setState({
      userId:
        sessionStorage.getItem("userId") == "" ||
          sessionStorage.getItem("userId") == null
          ? ""
          : sessionStorage.getItem("userId"),
      StatusID: this.props.location.state?.StatusID
        ? this.props.location.state?.StatusID
        : "",
    });
    console.log(this.props.location.state);
    const TimeSlotID = this.props.location.state?.TimeSlotID || "";
    if (TimeSlotID) {
      this.setState({ TimeSlotID }, () => {
        this.timeSlotDetails();
      });
    } else {
      this.clearFields();
    }
  }

  clearFields() {
    this.setState({
      TimeSlotName: "",
      FromTime: "",
      ToTime: "",
      SelectedHrs: "",
      Description: "",
    });
  }

  navigateBackList() {
    this.props.navigate("/timeSlot");
  }
  timeSlotDetails() {
    const { userId, TimeSlotID } = this.state;
    if (TimeSlotID) {
      this.props
        .timeslot_detail_action(TimeSlotID)
        .then((data) => {
          console.log("event details--------", data);
          if (data.error !== 1) {
            this.setState({
              TimeSlotName: data.data[0]["TimeSlotName"],
              SelectedHrs: data.data[0]["SelectedHrs"],
              Description: data.data[0]["Description"],
              StatusID: data.data[0]["StatusID"],
            });
            var slotType = (data.data[0]["FromTime"] === null && data.data[0]["ToTime"] === null) ? true : false;
            console.log(slotType, "slotType")
            var startTime;
            var endTime;
            if (slotType == true) {
              startTime = null;
              endTime = null;
            } else {
              startTime = data.data[0]["FromTime"].split(" ");
              endTime = data.data[0]["ToTime"].split(" ");
            }

            this.setState({
              FromTime: slotType == true ? startTime : startTime[0],
              ToTime: slotType == true ? endTime : endTime[0],
              slotType: slotType
            });

          } else {
            if (
              data.msg == sessionExpireMessage ||
              data.msg == tokenInavlidMessage
            ) {
              //after session expire.....................
              sessionStorage.clear();
              this.props.navigate("/normalView");
              setTimeout(() => {
                toast.error(data.msg, {
                  position: "top-center",
                  theme: "colored",
                  autoClose: 3000,
                  hideProgressBar: true,
                });
              }, 500);
            } else {
              toast.error(data.data, {
                position: "top-center",
                theme: "colored",
                autoClose: 3000,
                hideProgressBar: true,
              });
            }
          }
        })
        .catch((e) => {
          console.log(e);
        });
    }
  }

  inputValidate() {
    const { TimeSlotName, FromTime, ToTime, slotType, SelectedHrs } = this.state;
    if (TimeSlotName === "") {
      this.setState({ TimeSlotNameErr: "Please enter Time Slot Name" });
    }
    if (slotType == false) {
      if (FromTime === "" || FromTime == null) {
        this.setState({ FromTimeErr: "Please Select From Time" });
      }
      if (ToTime === "" || ToTime == null) {
        this.setState({ ToTimeErr: "Please Select To Time" });
      }
    } else {
      if (SelectedHrs === "" || SelectedHrs == null) {
        this.setState({ DurationErr: "Please Enter Duration" });
      }
    }
  }
  handleSubmit = async (event) => {
    event.preventDefault();
    const {
      userId,
      TimeSlotID,
      TimeSlotName,
      FromTime,
      ToTime,
      SelectedHrs,
      Description,
      StatusID,
      slotType,
    } = this.state;

    this.inputValidate();

    const formatTime = (time) => {
      const [hour, minute] = time.split(":");
      let formattedHour = parseInt(hour);
      let period = "AM";

      if (formattedHour >= 12) {
        period = "PM";
        if (formattedHour > 12) {
          formattedHour -= 12;
        }
      }
      if (formattedHour === 0) {
        formattedHour = 12; // Midnight case
      }
      return `${formattedHour}:${minute} ${period}`;
    };

    if (TimeSlotName === "") {
      this.setState({ isLoading: false });
      toast.error("Time Slot Name cannot be blank", {
        position: "top-center",
        theme: "colored",
        autoClose: 3000,
        hideProgressBar: true,
      });
      return; // Exit early if validation fails
    }

    if (slotType === false) {
      if (FromTime === "") {
        this.setState({ isLoading: false });
        toast.error("From Time cannot be blank", {
          position: "top-center",
          theme: "colored",
          autoClose: 3000,
          hideProgressBar: true,
        });
        return; // Exit early if validation fails
      }
      if (ToTime === "") {
        this.setState({ isLoading: false });
        toast.error("To Time cannot be blank", {
          position: "top-center",
          theme: "colored",
          autoClose: 3000,
          hideProgressBar: true,
        });
        return; // Exit early if validation fails
      }
      if (this.state.FromTimeErr || this.state.ToTimeErr) {
        toast.error("Invalid time slot", {
          position: "top-center",
          theme: "colored",
          autoClose: 3000,
          hideProgressBar: true,
        });
        return; // Exit early if validation fails
      }
    }

    if (slotType === true) {
      if (SelectedHrs === "" || SelectedHrs == null) {
        this.setState({ isLoading: false });
        toast.error("Duration cannot be blank", {
          position: "top-center",
          theme: "colored",
          autoClose: 3000,
          hideProgressBar: true,
        });
        return; // Exit early if validation fails
      }
    }

    this.setState({ isLoading: true });

    const finalStatus = StatusID == 0 ? 0 : StatusID == 1 ? 1 : 0;
    let formattedFromTime;
    let formattedToTime;
    if (slotType === false) {
      formattedFromTime =
        FromTime >= "00:00" && FromTime < "12:00"
          ? `${FromTime} AM`
          : formatTime(FromTime);
      formattedToTime =
        ToTime >= "00:00" && ToTime < "12:00"
          ? `${ToTime} AM`
          : formatTime(ToTime);
    } else {
      formattedFromTime = null;
      formattedToTime = null;
    }

    try {
      const data = await this.props.timeslot_add_action(
        TimeSlotID,
        TimeSlotName,
        formattedFromTime,
        formattedToTime,
        SelectedHrs,
        Description,
        finalStatus
      );

      if (data.error !== 1) {
        this.setState({ isLoading: false }, () => {
          toast.success(
            TimeSlotID ? "Updated Successfully" : "Submitted Successfully",
            {
              position: "top-center",
              theme: "colored",
              autoClose: 3000,
              hideProgressBar: true,
            }
          );
          setTimeout(() => {
            this.props.navigate("/timeSlot");
          }, 1000); // Adjust the delay time as needed
        });
      } else {
        if (
          data.msg === sessionExpireMessage ||
          data.msg === tokenInavlidMessage
        ) {
          // After session expire.....................
          sessionStorage.clear();
          this.props.navigate("/normalView");
          setTimeout(() => {
            toast.error(data.msg, {
              position: "top-center",
              theme: "colored",
              autoClose: 3000,
              hideProgressBar: true,
            });
          }, 500);
        } else {
          this.setState({ isLoading: false });
          toast.error(data.msg, {
            position: "top-center",
            theme: "colored",
            autoClose: 3000,
            hideProgressBar: true,
          });
        }
      }
    } catch (e) {
      console.log(e);
    }
  };

  onStartTime(e) {
    const { value } = e.target;
    const conditionChecked = value.split(":");

    let hour = parseInt(conditionChecked[0]);
    let minute = parseInt(conditionChecked[1]);

    if (isNaN(hour) || isNaN(minute)) {
      this.setState({ FromTime: "", SelectedHrs: "" });
      return;
    }

    // Normalize minutes to the nearest 15-minute interval
    minute = Math.round(minute / 15) * 15;

    // Update FromTime state
    this.setState({
      FromTime: `${hour}:${String(minute).padStart(2, "0")}`,
      FromTimeErr: "",
    });

    // Calculate SelectedHrs
    this.calculateSelectedHrs(
      hour,
      minute,
      this.state.ToTime.split(":")[0],
      this.state.ToTime.split(":")[1]
    );
  }

  onEndTime(e) {
    const { value } = e.target;
    const conditionChecked = value.split(":");

    let hour = parseInt(conditionChecked[0]);
    let minute = parseInt(conditionChecked[1]);

    if (isNaN(hour) || isNaN(minute)) {
      this.setState({ ToTime: "", SelectedHrs: "" });
      return;
    }

    // Normalize minutes to the nearest 15-minute interval
    minute = Math.round(minute / 15) * 15;

    // Update ToTime state
    this.setState({
      ToTime: `${hour}:${String(minute).padStart(2, "0")}`,
      ToTimeErr: "",
    });

    // Calculate SelectedHrs
    this.calculateSelectedHrs(
      this.state.FromTime.split(":")[0],
      this.state.FromTime.split(":")[1],
      hour,
      minute
    );
  }

  calculateSelectedHrs(fromHour, fromMinute, toHour, toMinute) {
    // Parse hour and minute values
    const fromHourInt = parseInt(fromHour);
    const fromMinuteInt = parseInt(fromMinute);
    const toHourInt = parseInt(toHour);
    const toMinuteInt = parseInt(toMinute);

    // Calculate difference in minutes
    let differenceInMinutes =
      toHourInt * 60 + toMinuteInt - (fromHourInt * 60 + fromMinuteInt);

    // Calculate selected hours as decimal value
    let selectedHrsDecimal = differenceInMinutes / 60;
    if (selectedHrsDecimal <= 0) {
      this.setState({
        FromTimeErr: "Invalid time slot",
        ToTimeErr: "Invalid time slot",
        SelectedHrs: "",
      });
      toast.error("Invalid time slot timing", {
        position: "top-center",
        theme: "colored",
        autoClose: 3000,
        hideProgressBar: true,
      });
    } else {
      this.setState(
        {
          SelectedHrs: selectedHrsDecimal.toFixed(2),
          FromTimeErr: "",
          ToTimeErr: "",
        },
        () => {
          console.log(this.state.SelectedHrs);
        }
      );
    }
  }

  render() {
    const {
      TimeSlotID,
      TimeSlotName,
      FromTime,
      ToTime,
      Description,
      SelectedHrs,
      StatusID,
      isLoading,
      TimeSlotNameErr,
      FromTimeErr,
      ToTimeErr,
      slotType, DurationErr
    } = this.state;
    return (
      <>
        {isLoading ? <Loader></Loader> : null}
        <>
          <main id="main">
            <Header data={[21]} />
            <div className="container-fluid">
              <section style={{ marginTop: 115 }}>
                <div className="page-header">
                  <h4 className="page-title">
                    {TimeSlotID ? "Edit" : "Add"} Time Slot
                  </h4>
                  <div className="Service_display pt-2">
                    <h6 className="Services_Active_or_Not">
                      {TimeSlotID
                        ? StatusID == 1
                          ? "Active"
                          : "Inactive"
                        : "Active"}
                    </h6>
                    <div className="checkbox checbox-switch">
                      <label className="switch">
                        {TimeSlotID ? (
                          <>
                            <input
                              type="checkbox"
                              checked={StatusID}
                              onChange={() => {
                                this.setState((prevState) => ({
                                  StatusID: !prevState.StatusID,
                                }));
                              }}
                            />
                            <span class="slider round"></span>
                          </>
                        ) : (
                          <>
                            <input type="checkbox" checked={1} />
                            <span class="slider round"></span>
                          </>
                        )}
                      </label>
                    </div>
                  </div>
                </div>
              </section>
              <div className="card">
                <div className="card-body">
                  <div className="row">
                    <div className="form-group col-md-2 mb-3">
                      <label htmlFor="inputZip">
                        Time Slot Name{" "}
                        <span className="mendatory_class">*</span>{" "}
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        maxLength={50}
                        id="fname"
                        name="name"
                        value={TimeSlotName}
                        onChange={(e) =>
                          this.setState({
                            TimeSlotName: e.target.value,
                            TimeSlotNameErr: "",
                          })
                        }
                      />
                      {
                        <span className="text-danger text-start text-left d-block mt-1">
                          {TimeSlotNameErr}
                        </span>
                      }
                    </div>
                    <div className="form-group col-md-2 mb-3">
                      <label htmlFor="inputZip">
                        Slot Type <span className="mendatory_class">*</span>{" "}
                      </label>
                      <div className="d-flex align-items-center">
                        <label className="switch mr-2">
                          <input
                            type="checkbox"
                            className="form-control"
                            checked={slotType}
                            onChange={() => {
                              this.setState((prevState) => ({
                                slotType: !prevState.slotType,
                                TimeSlotName: "",
                                FromTime: "",
                                ToTime: "",
                                SelectedHrs: "",
                                Description: "",
                              }));
                            }}
                          />
                          <span className="slider round"></span>
                        </label>
                        <span>
                          {slotType === false ? "Time Based" : "Duration Based"}
                        </span>
                      </div>
                    </div>
                  </div>
                  {slotType == false ? (
                    <>
                      <div className="row">
                        <div className="form-group col-md-2 mb-3">
                          <label htmlFor="inputZip">
                            From Time <span className="mendatory_class">*</span>{" "}
                          </label>

                          <TimePicker
                            className="time-picker"
                            value={FromTime}
                            onChange={(e) => this.onStartTime(e)}
                            step={60 * 15}
                            disableClock={true}
                            style={{ width: "15rem" }}
                          />
                          {
                            <span className="text-danger text-start text-left d-block mt-1">
                              {FromTimeErr}
                            </span>
                          }
                        </div>
                        <div className="form-group col-md-2 mb-3">
                          <label htmlFor="inputZip">
                            To Time <span className="mendatory_class">*</span>{" "}
                          </label>
                          <TimePicker
                            className="time-picker"
                            value={ToTime}
                            onChange={(e) => this.onEndTime(e)}
                            step={60 * 15}
                            disableClock={true}
                            style={{ width: "15rem" }}
                          />
                          {
                            <span className="text-danger text-start text-left d-block mt-1">
                              {ToTimeErr}
                            </span>
                          }
                        </div>
                        <div className="form-group col-md-2 mb-3">
                          <label htmlFor="inputZip">
                            Selected Hrs{" "}
                            <span className="mendatory_class">*</span>{" "}
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            maxLength={15}
                            id="fname"
                            name="name"
                            disabled
                            value={SelectedHrs}
                            onChange={(e) =>
                              this.setState({ SelectedHrs: e.target.value })
                            }
                          />
                        </div>
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="row">
                        <div className="form-group col-md-2 mb-3">
                          <label htmlFor="inputZip">
                            Duration (In Hrs){" "}
                            <span className="mendatory_class">*</span>{" "}
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            maxLength={15}
                            id="fname"
                            name="name"
                            value={SelectedHrs}
                            onChange={(e) =>
                              this.setState({ SelectedHrs: e.target.value })
                            }
                          />
                          {
                            <span className="text-danger text-start text-left d-block mt-1">
                              {DurationErr}
                            </span>
                          }
                        </div>
                      </div>
                    </>
                  )}
                  <div className="row">
                    <div className="form-group col-md-6 mb-3">
                      <label htmlFor="inputZip">Description</label>
                      <textarea
                        type="text"
                        className="form-control"
                        maxLength={200}
                        id="fname"
                        name="name"
                        value={Description}
                        onChange={(e) =>
                          this.setState({ Description: e.target.value })
                        }
                      ></textarea>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12">
                      <a
                        href="javascript:void(0);"
                        onClick={(e) => this.handleSubmit(e)}
                        className="btn save_btn mr-2"
                      >
                        {TimeSlotID ? "Update" : "Save"}
                      </a>
                      <a
                        href="javascript:void(0);"
                        onClick={() => this.navigateBackList()}
                        className="btn back_btn"
                        id="cancel_co_applicant_pop"
                      >
                        Back
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </main>
          <ToastContainer />
        </>
      </>
    );
  }
}

export default withRouter(
  connect(null, { timeslot_add_action, timeslot_detail_action })(seatingTypeAU)
);
